var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.557,
    height: 20,
    viewBox: "0 0 27.557 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3219",
    "data-name": "Group 3219",
    transform: "translate(-4858.716 -14240.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M4876.516,14243.108c-.9-1.543-2.443-.9-3.215-.9",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M4879.216,14252.622l-2.122,1.286-2.378-1.286-5.2,1.7a1.59,1.59,0,0,0-1.1,1.512v3.989h17.357v-3.976a1.59,1.59,0,0,0-1.114-1.517Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_717",
    "data-name": "Line 717",
    y2: 1.929,
    transform: "translate(4874.973 14250.822)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_718",
    "data-name": "Line 718",
    y1: 2.057,
    transform: "translate(4878.958 14250.822)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M4879.858,14244.779l-1.56.786a2.439,2.439,0,0,1-2.3.031l-1.8-.817-.684,1.415c0,2.371.427,5.4,3.513,5.4s3.512-3.028,3.512-5.4Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M4873.558,14246.065a3.553,3.553,0,0,1-.9-2.571c.385-1.958,2.915-2.508,3.215-2.572a4.646,4.646,0,0,1,2.957.386,3.53,3.53,0,0,1,2.186,2.187,3.443,3.443,0,0,1-.515,2.442",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_719",
    "data-name": "Line 719",
    y2: 3.471,
    transform: "translate(4882.43 14256.351)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_720",
    "data-name": "Line 720",
    y2: 3.471,
    transform: "translate(4871.63 14256.351)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M4872.973,14253.3l-4.586-1.419-.218-.087v-1.269c1.147-.84,1.31-4.322,1.31-4.322a2.925,2.925,0,0,0,.437-2.074,3,3,0,0,0-1.856-1.856,3.941,3.941,0,0,0-2.512-.327,4.472,4.472,0,0,0-2.146,1.091h-.037l.029.008a2.149,2.149,0,0,0-.575,1.084,3.012,3.012,0,0,0,.764,2.183s.15,3.26,1.2,4.13v1.339l-.218.1-4.419,1.442a1.351,1.351,0,0,0-.931,1.284v3.388h9.057",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.c432f298d2cb71c00b3a013b3806d0f2.svg";
export { ForwardRef as ReactComponent };